import { render, staticRenderFns } from "./wjx_home.vue?vue&type=template&id=05373b1c&scoped=true"
import script from "./wjx_home.vue?vue&type=script&lang=js"
export * from "./wjx_home.vue?vue&type=script&lang=js"
import style0 from "./wjx_home.vue?vue&type=style&index=0&id=05373b1c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05373b1c",
  null
  
)

export default component.exports